import { useEffect, useState } from 'react';
import { useAdminContext } from '../../context/AdminContext';
import Axios from '../../Axios';
import Header from '../utils/Header/Header';
import Menu from '../utils/Menu/Menu';
import Content from '../utils/Content/Content';

const Admin = () => {
  const { adminConfig, logoutHandler } = useAdminContext();

  const [isLoading, setIsLoading] = useState(true);
  const [role, setRole] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (!adminConfig) {
      setIsLoading(false);
      return;
    }

    Axios.get('/auth/me', adminConfig)
      .then((res) => {
        if (res.status === 200) {
          setRole(res.data.role_id);
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          logoutHandler();
          return;
        }

        setRole(0);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [adminConfig, logoutHandler]);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 1024) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    isLoading || (
      <main className='admin'>
        <Header
          role={role}
          logoutHandler={logoutHandler}
          isMenuOpen={isMenuOpen}
          onToggleMenu={() => setIsMenuOpen((prev) => !prev)}
        />
        <Menu role={role} isMenuOpen={isMenuOpen} />
        {isMenuOpen && (
          <button
            className='admin__menu-overlay'
            aria-label='Close menu'
            onClick={() => setIsMenuOpen(false)}
          />
        )}
        <Content role={role} />
      </main>
    )
  );
};

export default Admin;
